export const dispatchSessionEvent = (eventName: string, detail = {}) => {
    const event = new CustomEvent(eventName, { detail });
    window.dispatchEvent(event);
};
